/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description various labels mapping for  eligibility fhir
 */
import systemMapping from './fhirSystemMapping.json';

// code mapping
const codeMapping = {
	secondaryPayer: 'SEP',
	tertiaryPayer: 'TTP',
	primaryCareProvider: 'P3',
	primaryCareProviderEB: 'L',
};

const serviceTypeDisplayMapping = {
	ZZ: 'Place(s) of Service',
	GR: 'NCCI Nature of Injury Code',
	NI: 'Nature of Injury Code',
	44: 'Nature of Injury',
};

// HI segment mapping
const hiSegmentMapping = {
	icd9: 'ICD-9-CM',
	icd10: 'ICD-10-CM',
};
const mpiSegmentMapping = {
	[systemMapping['MPI-01']]: 'Information Status',
	[systemMapping['MPI-02']]: 'Employment Status',
	[systemMapping['MPI-03']]: 'Govt Service code',
	[systemMapping['MPI-05']]: 'Rank Code',
};

const modifiersSystem = [systemMapping['EB-13-03'], systemMapping['EB-13-04'], systemMapping['EB-13-05'], systemMapping['EB-13-06']];

const diagnosisCodesSystem = [systemMapping['EB-14-01'], systemMapping['EB-14-02'], systemMapping['EB-14-03'], systemMapping['EB-14-04']];

const labelMapping = {
	type: 'Type',
	name: 'Name',
	firstName: 'First Name',
	lastName: 'Last Name',
	gender: 'Gender',
	dob: 'Date of Birth',
	memberId: 'Member ID',
	serviceDate: 'Service Date',
	inquiryDate: 'Inquiry Date',
	address: 'Address',
	contact: 'Contact Details',
	insuranceType: 'Insurance Type',
	procedureCode: 'Procedure Code',
	modifiers: 'Modifiers',
	diagnosisCodes: 'Diagnosis Codes',
	planDescription: 'Plan Description',
	serviceDeliveryInfo: 'Service Delivery Information',
	providerInfo: 'Subscriber Benefit Related Provider Information',
	payerNotes: 'Payer Notes',
	mpiDescription: 'MPI Description',
	serviceSpan: 'Span of Service',
	relationship: 'Relationship',
	birthSeq: 'Birth Sequence',
	planName: 'Plan Name',
	payer: 'Payer',
	ssn: 'SSN',
	medicaidId: 'Medicaid ID',
	groupNumber: 'Group No.',
	state: 'State',
	accountNumber: 'Account No.',
	claimCategoryCode: 'Claim Category:',
	claimStatusCode: 'Claim Status:',
	paidAmount: 'Paid Amount',
	billedAmount: 'Billed',
	finalizedDate: 'Finalized Date',
	checkDate: 'Check/EFT Date',
	checkNumber: 'Check/EFT Number',
	claimServiceDates: 'Claim Service Dates',
	memberIdentificationNumber: 'Member Identification Number',
};

const customLabelMapping = {
	'Centers for Medicare and Medicaid Services National Provider Identifier': 'NPI',
	"Payor's Claim Number": "Payer's Claim Number",
	'Payor Identification': 'Payer Identification',
	'Referenced Transaction Trace Numbers': 'Ref. Transaction Trace No.',
	'Member Identification Number': 'Member ID',
	'Medical Record Identification Number': 'MRN',
};

export {
	codeMapping,
	serviceTypeDisplayMapping,
	hiSegmentMapping,
	mpiSegmentMapping,
	modifiersSystem,
	diagnosisCodesSystem,
	labelMapping,
	customLabelMapping,
};
